export default __webpack_public_path__ + "static/media/bpt-acre.6cf05d9d.png";